import { createFileRoute } from '@tanstack/react-router';

import { AttendancePage } from '@/features/parent/AttendancePage';

export const Route = createFileRoute('/_authed/parent/attendance')({
  component: AttendancePage,
});
